import React, { createContext, useContext, useEffect, useState } from 'react';

const AdminContext = createContext(null);

const AUTH_KEY = 'admin_auth';
const ADMIN_USERNAME = 'admin';
const ADMIN_PASSWORD = 'admin123';

function loadAuth() {
  try {
    return localStorage.getItem(AUTH_KEY) === 'true';
  } catch {
    return false;
  }
}

export function AdminProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(loadAuth);

  useEffect(() => {
    localStorage.setItem(AUTH_KEY, String(isAuthenticated));
  }, [isAuthenticated]);

  const login = (username, password) => {
    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const logout = () => setIsAuthenticated(false);

  const value = {
    isAuthenticated,
    login,
    logout,
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return ctx;
}
